export type Props = {
  dir?: 'ltr' | 'rtl'
  lang?: string
}

export type PlacemarkType = 'source' | 'destination' | 'numeric'

export const enum DeliveryType {
  Express = 'express',
  SDD = 'sdd',
  NDD = 'ndd',
  Courier = 'courier',
  Cargo = 'cargo',
  Night = 'night',
  NDD_Self_Pickup = 'ndd_self_pickup',
  NDD_Shipment = 'ndd_shipment',
  Walking_Courier = 'walking_courier',
}

export const enum SourcePointDeliveryMethod {
  Station = 'station',
  DropOffPoint = 'dropOffPoint',
}

export const enum DestinationPointDeliveryMethod {
  Address = 'address',
  PickUpPoint = 'pickUpPoint',
}
